const documentationOrigins: Readonly<Record<string, string>> = {
  'dev.connectplane.com': 'https://docs.dev.connectplane.com',
  'staging.connectplane.com': 'https://docs.staging.connectplane.com',
  'connectplane.com': 'https://docs.connectplane.com',
  'www.connectplane.com': 'https://docs.connectplane.com',
};

export function developerDocumentationOrigin(hostname: string) {
  return documentationOrigins[hostname.toLowerCase()] ?? 'http://localhost:5185';
}

export function developerDocumentationUrl(hostname: string, legacyPath?: string) {
  const origin = developerDocumentationOrigin(hostname);
  if (!legacyPath || legacyPath === '/docs/api') return `${origin}/`;
  if (legacyPath === '/docs/api/changelog' || legacyPath === '/changelog') return `${origin}/changelog`;
  if (legacyPath.startsWith('/docs/api/')) return `${origin}/${legacyPath.slice('/docs/api/'.length)}`;
  return `${origin}/`;
}

export function apiChangelogUrl(hostname: string) {
  return `${developerDocumentationOrigin(hostname)}/changelog`;
}
